import { __assign, __decorate, __extends, __rest } from "tslib";
import * as React from 'react';
import s from './terminator.scss';
import { getCtaUrl } from '../terminator-data';
import { config } from '../../../../config';
import { withBiLogger } from '../../../../component-decorators/with-bi-logger';
import { withMarketplaceStore, } from '../../../../component-decorators/with-marketplace-store';
import { Box, Heading, Text, Button } from 'wix-style-react';
import { composer } from '../../../../component-decorators/composer';
export var terminatorSuggestionToTerminatorProps = function (term, suggestion, marketplaceStore) {
    var titleKey = suggestion.titleKey, descriptionKey = suggestion.descriptionKey, iconUrl = suggestion.iconUrl, ctaUrl = suggestion.ctaUrl, spec = suggestion.spec, regex = suggestion.regex;
    var msid = marketplaceStore.metaSiteId;
    var useIconUrl = iconUrl.startsWith('http')
        ? iconUrl
        : config.marketplaceStaticsUrl + "/assets/images/terminator-icons/" + iconUrl;
    return {
        term: term,
        titleKey: titleKey,
        descriptionKey: descriptionKey,
        iconUrl: useIconUrl,
        cta: function () { return window.open(getCtaUrl(suggestion, msid), '_blank'); },
        experimentName: spec,
    };
};
export var Terminator = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, props = __rest(_a, ["t"]);
    return (React.createElement(TerminatorComponent, __assign({ t: t }, props)));
});
var TerminatorComponent = /** @class */ (function (_super) {
    __extends(TerminatorComponent, _super);
    function TerminatorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerminatorComponent.prototype.sendTerminatorRenderBiEvent = function () {
        var _a = this.props, biLogger = _a.biLogger, term = _a.term, experimentName = _a.experimentName, marketplaceStore = _a.marketplaceStore;
        biLogger.appMarketTerminatorPresenteToUser({
            experiment_name: experimentName,
            market: config.originForBI,
            msid: marketplaceStore.metaSiteId,
            search_term: term,
        });
    };
    TerminatorComponent.prototype.sendTerminatorCtaClickBiEvent = function () {
        var _a = this.props, biLogger = _a.biLogger, term = _a.term, experimentName = _a.experimentName, marketplaceStore = _a.marketplaceStore;
        biLogger.appMarketTerminatorLearnHowClick({
            experiment_name: experimentName,
            market: config.originForBI,
            msid: marketplaceStore.metaSiteId,
            search_term: term,
        });
    };
    TerminatorComponent.prototype.componentDidMount = function () {
        this.sendTerminatorRenderBiEvent();
    };
    TerminatorComponent.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.term !== nextProps.term;
    };
    TerminatorComponent.prototype.componentDidUpdate = function (prevProps) {
        this.sendTerminatorRenderBiEvent();
    };
    TerminatorComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, titleKey = _a.titleKey, descriptionKey = _a.descriptionKey, iconUrl = _a.iconUrl, cta = _a.cta, t = _a.t;
        return (React.createElement(Box, { align: 'space-between', className: s.terminator, dataHook: 'terminator' },
            React.createElement(Box, { direction: 'vertical' },
                React.createElement(Heading, { appearance: 'H2', dataHook: 'terminator-title' }, t(titleKey)),
                React.createElement(Text, { tagName: 'div', className: s.description, dataHook: 'terminator-description' }, t(descriptionKey)),
                React.createElement(Button, { onClick: function () {
                        _this.sendTerminatorCtaClickBiEvent();
                        cta();
                    }, className: s.cta, dataHook: 'terminator-cta' }, t('terminator.learnHow'))),
            React.createElement("img", { src: iconUrl, className: s.icon, alt: '', "data-testid": 'terminator-icon' })));
    };
    TerminatorComponent = __decorate([
        withMarketplaceStore,
        withBiLogger
    ], TerminatorComponent);
    return TerminatorComponent;
}(React.Component));
//# sourceMappingURL=terminator.js.map